goog.provide('yext.location.OptionListModel');
goog.provide('yext.location.OptionList');

goog.require('yext');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * Model for the option list field, which contains options
 *
 * @param {OptionListModel.OptionList} options
 *
 * @constructor
 * @author Vincent Vuong (vvuong@yext.com)
 */
yext.location.OptionListModel = function(data) {
  this.setOptions(data);
};

/**
 * Update options in model
 *
 * @param {!Object} values, and indeterminate
 */
yext.location.OptionListModel.prototype.setOptions = function(data) {
  var values = [];
  var displayValues = [];
  data.values.forEach(function(option) {
    values.push(new yext.location.OptionListModel.Option(option));
  });
  data.displayValues.forEach(function(option) {
    displayValues.push(new yext.location.OptionListModel.Option(option));
  });

  this.values = values;
  this.displayValues = displayValues;
  this.indeterminate = data.indeterminate;
  this.displayIndeterminate = data.displayIndeterminate;
};

/**
 * Checks if no options are selected
 *
 * @return {boolean} True if empty
 */
yext.location.OptionListModel.prototype.isEmpty = function() {
  for (var i = 0; i < this.values.length; i++) {
    if (this.values[i].selected) {
      return false;
    }
  }
  return true;
};

/**
 * Checks if no options are selected in view mode
 *
 * @return {boolean} True if empty
 */
yext.location.OptionListModel.prototype.isDisplayEmpty = function() {
  for (var i = 0; i < this.displayValues.length; i++) {
    if (this.displayValues[i].selected) {
      return false;
    }
  }
  return true;
};

/**
 * Get a option by value
 *
 * @param {OptionListModel.Option}
 */
yext.location.OptionListModel.prototype.getOption = function(value) {
  for (var i = 0; i < this.values.length; i++) {
    if (this.values[i].value == value) {
      return this.values[i];
    }
  }
};

/**
 * Update options in model
 *
 * @param {OptionListModel.Option}
 */
yext.location.OptionListModel.prototype.setOptionSelected = function(value, selected) {
  var option = this.getOption(value);
  if (option != null) {
    option.selected = selected;
    option.indeterminate = false;
    this.emitUpdate();
  }
};

/**
 * Trigger a message on the OptionListModel
 *
 * @param {string} message Message to trigger
 */
yext.location.OptionListModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * The model for each optionList
 *
 * @constructor
 * @author Vincent Vuong (vvuong@yext.com)
 */
yext.location.OptionListModel.Option = function(data) {
  this.label = data.label;
  this.value = data.value;
  this.selected = data.selected;
  this.indeterminate = data.indeterminate;
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.OptionList = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = this.$ctx.find('.js-field-value');
  this.$optionList = $ctx.find('.js-option-list');
  this.$row = $ctx.closest('.field-display');
  this.$displayOptionList = this.$row.find('.js-display-option-list');

  this.parseDataFromDOM();
  this.storeValue();
  this.setFieldValue();
  this.bindUpdates();
  this.render();

  this.assetOrOriginal = true;
  this.originalValue = this.$fieldValue.val();
};

/**
 * Parse the initial data from the DOM
 */
yext.location.OptionList.prototype.parseDataFromDOM = function() {
  var values = [];
  var displayValues = [];
  this.$optionList.find('ul input').each(function() {
    var $this = $(this);
    values.push(new yext.location.OptionListModel.Option({
      label: $this.attr('label'),
      value: $this.val(),
      selected: $this.is(':checked'),
      indeterminate: $this.data('indeterminate'),
    }));
  });
  if (this.$displayOptionList) {
    this.$displayOptionList.find('ul input').each(function() {
      var $this = $(this);
      displayValues.push(new yext.location.OptionListModel.Option({
        label: $this.attr('label'),
        value: $this.val(),
        selected: $this.is(':checked'),
        indeterminate: $this.data('indeterminate'),
      }));
    });
  }

  this.model = new yext.location.OptionListModel({
    values: values,
    displayValues: displayValues,
    indeterminate: this.$ctx.data('indeterminate'),
    displayIndeterminate: this.$row.find('.various').length > 0,
  });
  this.timestamp = this.$ctx.data('timestamp');
};

/**
 * Store the state for use in reset
 */
yext.location.OptionList.prototype.storeValue = function() {
  this.storedModel = new yext.location.OptionListModel(this.model);
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.location.OptionList.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getJSONData()));
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.OptionList.prototype.bindUpdates = function() {
  var self = this;

  this.$optionList.find('ul input').inputchange(function() {
    var $this = $(this);
    self.model.setOptionSelected($this.val(), self.model.getOption($this.val()).indeterminate ? true : $this.is(':checked'));
  });

  $(this.model).on('updated', function() {
    self.render();
    self.setFieldValue();
    self.emitUpdate();
  });
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} message Message to trigger
 */
yext.location.OptionList.prototype.emitUpdate = function() {
  $(this).trigger('updated');
  $(this).trigger('update.struct');
  this.updateAssetOrOriginal(false);
};

/**
 * Reset the field to a stored state
 */
yext.location.OptionList.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the model data
 *
 * @param {!Object} field Field data
 */
yext.location.OptionList.prototype.set = function(field) {
  this.model.setOptions(field);

  if (field.timestamp) {
    this.timestamp = field.timestamp;
  }

  this.render();
};

/**
 * Render the current state of the model
 */
yext.location.OptionList.prototype.render = function() {
  var values = {};

  this.model.values.forEach(function(option) {
    values[option.value] = option;
  });

  this.$optionList.find('ul input').each(function() {
    var $this = $(this);
    $this.prop({
      checked: values[$this.val()].selected,
      indeterminate: values[$this.val()].indeterminate,
    });
  });
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.OptionList.prototype.getJSONData = function() {
  return {
    'values': this.model.values,
    'timestamp': this.timestamp,
  };
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
yext.location.OptionList.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues);
  $(this).trigger('update.struct');
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
yext.location.OptionList.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$fieldValue.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
yext.location.OptionList.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * @param {!Object} fieldValues the value to update
 * @param {!jQuery} $display where the values go
 * @param {!jQuery} $viewTemplate _unused_
 * @param {boolean} cannotEdit
 */
yext.location.OptionList.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate, cannotEdit) {
  this.set(fieldValues);
  this.storeValue();

  $display.empty().append(this.getDisplayValue(cannotEdit));

  // reset asset approvals values
  this.assetOrOriginal = true;
  this.originalValue = this.$fieldValue.val();
};

/**
 * Get display value for option list
 * @param {boolean} cannotEdit
 */
yext.location.OptionList.prototype.getDisplayValue = function(cannotEdit) {
  if (this.model.displayIndeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.model.isDisplayEmpty()) {
    return yext.location.helpers.emptyFieldMessage(cannotEdit);
  }

  var html = '<ul>';
  this.model.displayValues.forEach(function(option) {
    if (option.selected) {
      html += '<li class="display-option" data-value="' + option.value +
        '" tid="multi-option-item-display">' + option.label + '</li>';
    }
  });
  html += '</ul>';
  return html;
};

/**
 * clear all values
 */
yext.location.OptionList.prototype.clear = function() {
  this.$optionList.find('ul input').each(function() {
    $(this).prop('checked', false);
  });
  this.parseDataFromDOM();
};
